export function stringToInt(value: string): number {
  const parsedValue = parseInt(value);
  if (isNaN(parsedValue)) {
    throw new Error("Invalid string value");
  }
  return parsedValue;
}

export function stringToFloat(value: string): number {
  const parsedValue = parseFloat(value.replace(",", "."));
  if (isNaN(parsedValue)) {
    throw new Error("Invalid string value");
  }
  return parsedValue;
}
